import apiClient from '../apiClient';
import { PUT_TOUR_OPERATOR_MARGIN_URL } from '../apiUrl';

const putTourOperatorSystemMarginApi = (id, data) => {
  return apiClient.put(PUT_TOUR_OPERATOR_MARGIN_URL(id), data);
};

export default putTourOperatorSystemMarginApi;
